<template>

  <div style="position:relative;overflow:hidden;">
    <!-- <div v-if="accountLevel===3||accountLevel==='3'" class="user_mask"></div>

    <input v-if="level>1&&(accountLevel!==2)&&(accountLevel!==3)" -->
        <input v-if="level>1&&(accountLevel!==2)"
           type="button"
           @click="backFunc"
           value="<返回"
           class="back-btn"
           style="">
    <div :id="id"
         class="o-echarts">

    </div>

  </div>

</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
let level1Data = [

  {
    name: '哈尔滨市',
    value: 230100,
    itemStyle: {
      //  areaColor: '#54b9ff'

    }
  },
  {
    name: '齐齐哈尔市',
    value: 230200,
    itemStyle: {
      // areaColor: '#13d7d6'
    }
  },
  {
    name: '鸡西市',
    value: 230300,
    itemStyle: {
      // areaColor: '#54b9ff'
    }
  },
  {
    name: '鹤岗市',
    value: 230400,
    itemStyle: {
      // areaColor: '#5e6dfa'
    }
  },
  {
    name: '双鸭山市',
    value: 230500,
    itemStyle: {
      // areaColor: '#ae6ff1'
    }
  },
  {
    name: '大庆市',
    value: 230600,
    itemStyle: {
      // areaColor: '#a3abff'
    }
  },
  {
    name: '伊春市',
    value: 230700,
    itemStyle: {
      // areaColor: '#707ef9'
    }
  },
  {
    name: '佳木斯市',
    value: 230800,
    itemStyle: {
      // areaColor: '#13d7d6'
    }
  },
  {
    name: '七台河市',
    value: 230900,
    itemStyle: {
      // areaColor: '#a3abff'
    }
  },
  {
    name: '牡丹江市',
    value: 231000,
    itemStyle: {
      // areaColor: '#707ef9'
    }
  },
  {
    name: '黑河市',
    value: 231100,
    itemStyle: {
      // areaColor: '#ae6ff1'
    }
  },
  {
    name: '绥化市',
    value: 231200,
    itemStyle: {
      // areaColor: '#a3abff'
    }
  },
  {
    name: '大兴安岭地区',
    value: 232700,
    itemStyle: {
      // areaColor: '#707ef9'
    }
  }

]
const itemStyle = {
  // areaStyle: {
  //   shadowColor: 'rgba(67, 171, 234, 0.5)',
  //   shadowBlur: 20

  // },

  // borderColor: '#fff',
  normal: {
    // areaColor: 'rgba(0,0,0,0)',
    borderColor: '#389dff',
    borderWidth: 1.6, // 设置外层边框
    // shadowBlur: 5,
    // shadowOffsetY: 8,
    // shadowOffsetX: 0,
    // shadowColor: '#01012a',
    areaColor: {
      type: 'radial',
      x: 0.5,
      y: 0.5,
      r: 0.8,
      colorStops: [
        {
          offset: 0.1,
          color: 'rgba(12, 45, 120, 0.2)' // 0% 处的颜色
        },
        {
          offset: 1,
          color: 'rgba(12, 45, 120, 0.9)' // 100% 处的颜色
        }
      ],
      globalCoord: false // 缺省为 false
    }

  },
  emphasis: {
    // show: false,
    areaColor: '#43abf3',
    label: {
      color: '#fff'
    }
  }

}
let echartObj = null
export default {
  name: 'MapChart',

  props: {
    id: {
      type: String, // 数据类型
      default: null // 初始值
    }
  },
  data () {
    return {
      accountLevel: 1, // 当前账户级别省、市、区县
      accountCode: 23,
      accountName: '黑龙江',
      parentName: '',
      parentCode: '',
      level1Data,
      // id: 'mapId',//地图渲染容器id
      // echartObj: null,
      jsonName: '', // 地图加载文件
      level: 1, // 地图加载层级1省、2市
      option: {
        title: {
          text: '',
          subtext: ''
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>{c}000000',
          backgroundColor: '#103164',
          borderColor: '#2a69c6',
          textStyle: {
            color: '#c6e1fc',
            fontSize: 12
            // fontWeight: 'bold',
            // padding: 4
          }

        },

        series: [
          {
            name: '',
            type: 'map',
            mapType: '黑龙江', // 自定义扩展图表类型HK
            zoom: 1,
            label: {
              show: true,
              color: '#a8cdff',
              fontSize: 11
            },
            center: ['50%', '50%'],
            projection: {
              project: (point) => [point[0] / 180 * Math.PI, -Math.log(Math.tan((Math.PI / 2 + point[1] / 180 * Math.PI) / 2))],
              unproject: (point) => [point[0] * 180 / Math.PI, 2 * 180 / Math.PI * Math.atan(Math.exp(point[1])) - 90]
            },
            itemStyle,
            emphasis: {
              itemStyle: {
                areaColor: '#fff'
              }
            },

            data: [],
            // 自定义名称映射
            nameMap: {
              //   '哈尔滨市': 230100,
              //   '齐齐哈尔市': 230200,
              //   '鸡西市': 230300,
              //   '鹤岗市': 230400,
              //   '双鸭山市': 230500,
              //   '大庆市': 230600,
              //   '伊春市': 230700,
              //   '佳木斯市': 230800,
              //   '七台河市': 230900,
              //   '牡丹江市': 231000,
              //   '黑河市': 231100,
              //   '绥化市': 231200,
              //   '大兴安岭地区': 232700
            }

          }
        ]
      }

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    // 重置大小
    window.addEventListener('resize', () => {
      this.listenResize()
    })
    this.initMap()
  },
  watch: {

  },
  methods: {
    /** 监听窗口尺寸改变 */
    listenResize () {
      echartObj.resize()
    },
    /** 初始化 */
    initMap () {
      let account = this.$store.state.account
      this.accountLevel = account.user.level
      console.log('account.user.level:', account.user.level)

      // let code = 23
      // let name = '黑龙江'
      // if (this.accountLevel === 2 || this.accountLevel === 3) {
      //   // 市级与区县账户
      if (this.accountLevel === 2) {
        // 市级账户
        this.accountCode = Number(account.userArea.city.toString().substr(0, 6))
        this.accountName = account.userArea.city_name
        // 设置level1Data
        // this.level1Data=
      }
      this.getJsonName(this.accountCode)// 首次获取地区json
      // let color = this.setRandomColor(index)

      // if (this.accountLevel === 1) {
      //   this.level1Data = this.jsonName.features.map((i, index) => {
      //     console.log(i)
      //     let properties = i.properties
      //     properties.itemStyle = { 'areaColor': color}
      //     return i
      //   })
      // }

      // if (this.accountLevel === 2 || this.accountLevel === 3) {
      //   // 市级与区县账户
      if (this.accountLevel === 2) {
        // 市级账户
        // let color = ['#707ef9', '#ae6ff1', '#13d7d6', '#a3abff', '#54b9ff', '#a3abfe', '#5e6dfa']
        this.level1Data = this.jsonName.features.map((i, index) => {
          // 设置颜色随机
          // let colorItem = index
          // if (index >= color.length) {
          //   colorItem = index % (color.length - 1)
          // }
          // let color = this.setRandomColor(index)
          // 返回数据
          return {
            name: i.properties.name,
            value: Number(i.properties.id),
            itemStyle
          }
        })
      }

      echartObj = echarts.init(document.getElementById(this.id))

      echarts.registerMap(this.accountName, this.jsonName)
      /// /////////////////////////////
      // 设置样式
      this.option.series[0].itemStyle = {
        // areaStyle: {
        //   shadowColor: 'rgba(67, 171, 234, 0.5)',
        //   shadowBlur: 20

        // },

        // borderColor: '#fff',
        normal: {
          // areaColor: 'rgba(0,0,0,0)',
          borderColor: '#389dff',
          borderWidth: 1.6, // 设置外层边框
          // shadowBlur: 5,
          // shadowOffsetY: 8,
          // shadowOffsetX: 0,
          // shadowColor: '#01012a',
          areaColor: {
            type: 'radial',
            x: 0.5,
            y: 0.5,
            r: 0.8,
            colorStops: [
              {
                offset: 0.1,
                color: 'rgba(12, 45, 120, 0)' // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(12, 45, 120, 0.9)' // 100% 处的颜色
              }
            ],
            globalCoord: false // 缺省为 false
          }

        },
        emphasis: {
          // show: false,
          areaColor: '#43abf3',
          label: {
            color: '#fff'
          }
        }

      }
      /// /////////////////////////////////////////
      this.option.series[0].data = this.level1Data
      this.option.series[0].mapType = this.accountName

      echartObj.setOption(this.option, true)
      // sh
      echartObj.on('rendered', function () {
        // console.info('end', Date().toString())
      })

      echartObj.on('click', (param) => {
        // console.log('地图点击：', param, this.level)

        if (!param.event.target.selected && this.level.toString() === '2') {
          // // 取消点击显示上级数据
          let params = {...param}
          // params.data = {
          //   value: this.parentCode,
          //   name: this.parentName
          // }
          params.name = this.parentName
          params.value = this.parentCode
          this.level = this.level - 1

          params.level = this.level

          console.log('params', params.data)
          this.$emit('mapChartFun', {...params})

          this.drawMap(params)

          // location.reload()
          return
        }

        if (param.data) {
          if (this.level < 2) {
            this.parentName = param.data.name
            this.parentCode = param.data.value
          }

          console.log(param.data)
          try {
            this.$emit('mapChartFun', Object.assign(param, { level: this.level }))
          } catch (e) {
            console.log(e)
          }

          this.drawMap(param)
        }
      })
    },
    /** 随机颜色生成
     * @params color:Array  随机颜色数组
     * @params index:Number  区域索引
     *
    */
    setRandomColor (index, colors) {
      // let color = ['#707ef9', '#ae6ff1', '#13d7d6', '#a3abff', '#54b9ff', '#a3abfe', '#5e6dfa']
      let color = ['', '', '', '', '', '', '']
      if (colors && colors.length > 1) {
        color = colors
      }
      let colorItem = index
      if (index >= color.length) {
        colorItem = index % (color.length - 1)
      }

      return color[colorItem]
    },
    /** 渲染地图区域 */
    drawMap (param) {
      if (this.level === 1) {
        this.level += 1
      } else if (this.level > 1) {
        //  this.level = 1
        //   let that = this;
        //   this.getJsonName(23);//首次获取黑龙江省json
        //   echarts.registerMap('黑龙江', this.jsonName);
        //   this.option.series[0].data = level1Data
        //   this.option.series[0].mapType = '黑龙江'

        //   delete this.option.visualMap
        //   echartObj.setOption(this.option, true);
        //    this.back=false
        return
      }

      let that = this
      let name = param.name
      let code = param.value
      that.getJsonName(code)
      // let color = ['#707ef9', '#ae6ff1', '#13d7d6', '#a3abff', '#54b9ff', '#a3abfe', '#5e6dfa']
      if (!that.jsonName) { return }
      that.option.series[0].data = that.jsonName.features.map((item, index) => {
        // 设置颜色随机
        // let colorItem = index
        // if (index >= color.length) {
        //   colorItem = index % (color.length - 1)
        // }
        let color = this.setRandomColor(index)

        return {
          name: item.properties.name,
          value: parseInt(item.properties.id),
          itemStyle: {
            // color: '#a3abff'
            color

          }
        }
      })
      that.option.series[0].data.sort(that.sortBy('value'))
      that.option.series[0].mapType = name

      that.option.visualMap = {
        show: false,
        min: that.option.series[0].data[0].value,
        max: that.option.series[0].data[that.option.series[0].data.length - 1].value,
        text: ['High', 'Low'],
        realtime: false,
        calculable: true,
        inRange: {
          color: ['#707ef9', '#ae6ff1', '#13d7d6', '#a3abff', '#54b9ff', '#a3abfe', '#5e6dfa']
        }
      }
      // Object.assign(that.option,visualMap)
      echartObj = echarts.init(document.getElementById(that.id))
      if (that.jsonName) {
        echarts.registerMap(name, that.jsonName)
      }

      echartObj.setOption(that.option, true)
    },
    backFunc () {
      echartObj.clear()
      echartObj.dispose()
      this.level = 1
      this.getJsonName(23)// 首次获取黑龙江省json
      echarts.registerMap('黑龙江', this.jsonName)
      this.option.series[0].data = level1Data
      this.option.series[0].mapType = '黑龙江'

      delete this.option.visualMap
      echartObj.setOption(this.option, true)
      this.$emit('mapChartFun', Object.assign({}, { level: 0 }))
      this.initMap()
    },
    sortBy (props) {
      return function (a, b) {
        return a[props] - b[props]
      }
    },
    getJsonName (name) {
      try {
        this.jsonName = (name === 23) ? require('./mapJSON/geometryProvince/' + name + '.json') : require('./mapJSON/geometryCouties/' + name + '.json')
      } catch (e) {
        // console.error(e)
      }
    }

  },
  components: {

  }
  // beforeDestroy () {
  //   window.removeEventListener("resize");
  // },
}
</script>

<style scoped lang="">
.o-echarts {
  min-width: 30px;
  min-height: 30px;
  height: 550px;
  margin: 0 auto;
}
.back-btn {
  position: absolute;
  bottom: 50px;
  right: 70px;
  cursor: pointer;
  z-index: 999;
  background-color: #103164;
  border: 1px solid #2a69c6;
  color: #c6e1fc;
  font-size: 12px;
}
/* 定义自定义蒙层,区县禁止点击地块 地图组件无法控制 */
.user_mask{
 position: absolute;
 left: 30px;
 top: 20;
 width:84%;
 height: 90%;
 background: rgba(255, 255, 255,0);
 z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/components/v1/Map/index.vue